import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { setPatientIncorporationRequestService } from 'services/setPatientIncorporationRequestService'
import inputValidate from 'utils/inputValidate'

const useFormPatientInformedConsent = () => {
    const navigate = useNavigate()
    const [isFetching, setIsFetching] = useState(false)

    const initialFormState = {
        patient: {
            names: '',
            surnames: '',
            // email: '',
            mobile: '',
            product: '',
            therapeuticIndication: '',
        },
        professional: {
            names: '',
            surnames: '',
            // email: '',
            // specialty: '',
            // professionalRegistration: '',
        },
    }

    const [formState, setFormState] = useState({ ...initialFormState })
    const [formErrorsState, setFormErrorsState] = useState({ ...initialFormState })

    //* Handle Input Change
    const handleInputChange = (inputName, inputValue, fieldset, minLength) => {
        const isProfessionalField = fieldset === 'professional'

        const newFormState = {
            patient:
                fieldset === 'patient'
                    ? { ...formState.patient, [inputName]: inputValue }
                    : { ...formState.patient },
            professional:
                fieldset === 'professional'
                    ? { ...formState.professional, [inputName]: inputValue }
                    : { ...formState.professional },
        }

        setFormState({ ...newFormState })

        if (!isProfessionalField) {
            const validationResult = inputValidate({ inputName, inputValue, minLength })
            setFormErrorsState((prev) => ({
                ...prev,
                [fieldset]: {
                    ...prev[fieldset],
                    [inputName]: validationResult,
                },
            }))
        }
    }

    //* Handle Submit
    const handleSubmit = async (e) => {
        e.preventDefault()
        setIsFetching(true)
        const submitErrors = []

        Object.keys(formState.patient).forEach((input) => {
            const error = inputValidate({
                inputName: input,
                inputValue: formState.patient[input],
            })
            if (error) {
                submitErrors.push(`patient_${input}`)
                setFormErrorsState((prev) => ({
                    ...prev,
                    patient: { ...prev.patient, [input]: error },
                }))
            }
        })

        if (submitErrors.length > 0) {
            setIsFetching(false)
        } else {
            const result = await setPatientIncorporationRequestService({
                patient: { ...formState.patient },
                professional: { ...formState.professional },
            })
            if (result.status) {
                setTimeout(function () {
                    navigate('/')
                }, 3000)
            }
            setIsFetching(false)
        }
    }

    return {
        patientData: formState.patient,
        professionalData: formState.professional,
        errors: formErrorsState,
        isFetching,
        handleInputChange,
        handleSubmit,
    }
}

export default useFormPatientInformedConsent
